export const baseUrl = "https://api-pegasus.flixstudio.io/api/v1";


// export const baseUrl="http://localhost:3009/api/v1";